import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const HarriEngageRoutes = [
    {
        "url": "/brand/:brand_id/harri-engage?tab",
        "name": "appLayout.harriSH.harri-engage",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            tab: "",
        },
        "component": "harriEngage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage", "dashboards", 'centralized-settings']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/harri-engage/${hmapPathParamRegex}?tab`,
        "name": "appLayout.harriSH.access-portal.settings.harri-engage",
        "type": "frontend",
        "showSettingsHeader": true,
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
            tab: "",
        },
        "component": "harriEngage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage", "dashboards", 'centralized-settings']
        },
        "onEnter": ['$stateParams', '$state', 'hmapService', 'userPermissions', 'brandServices', async function ($stateParams, $state, hmapService, userPermissions, brandServices) {
                const activeBrandId = hmapService.getActiveBrandId($stateParams['hmapPath']);
                const [policyParser, isHarriEngageEnabled, isOnboardingJourneyEnabled] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrandId),
                    brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, activeBrandId),
                    brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, activeBrandId)
                ]);
                if (isOnboardingJourneyEnabled && policyParser.has(userPermissions.PERMISSIONS['MANAGE_ON_BOARDING_JOURNEY_EVENTS'])) {
                    return;
                }
                if (!isHarriEngageEnabled || !policyParser.has(userPermissions.PERMISSIONS['MANAGE_TOUCHPOINTS'])) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
                const isHarriEngageActivated = (await HarriEngageServiceAPI.checkBrandLevelActivation(activeBrandId)).is_level_activated;
                if (!isHarriEngageActivated) {
                    Utils.redirectToWorkspace('appLayout.harriSH.access-portal.main', { hmapPath: $stateParams['hmapPath'] });
                }
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/touchpoint-details/:touch_point_id?mode",
        "name": "appLayout.harriSH.edit-touchpoint",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "manageTouchpoints",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/touchpoint-details/:touch_point_id/${hmapPathParamRegex}?mode`,
        "name": "appLayout.harriSH.access-portal.settings.edit-touchpoint",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "manageTouchpoints",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/create-touchpoint?mode",
        "name": "appLayout.harriSH.create-touchpoint",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "manageTouchpoints",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/create-touchpoint/${hmapPathParamRegex}?mode`,
        "name": "appLayout.harriSH.access-portal.settings.create-touchpoint",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "manageTouchpoints",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/brand/:brand_id/engage-bot-settings",
        "name": "appLayout.harriSH.access-portal.settings.engage-bot-settings",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "component": "engageBotSettings",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["harri-engage"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/harri-engage/harri-engage.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=harri-engage.routes.js.map